module.exports = __webpack_public_path__ + "img/maestro-old.10658eed.svg";